import plugin from 'tailwindcss/plugin'

import { convertWeight, pxToEm, pxToRem } from './typography'

export const marketingTypographyConfig = {
  website: {
    'title-large': {
      desktop: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(56),
        lineHeight: pxToRem(64),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(44),
        lineHeight: pxToRem(48),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'title-medium': {
      desktop: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(44),
        lineHeight: pxToRem(56),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(24),
        lineHeight: pxToRem(32),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'title-small': {
      desktop: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(44),
        lineHeight: pxToRem(56),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(24),
        lineHeight: pxToRem(32),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    heading: {
      desktop: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(36),
        lineHeight: pxToRem(44),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(22),
        lineHeight: pxToRem(26),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    subheading: {
      desktop: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(22),
        lineHeight: pxToRem(28),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(20),
        lineHeight: pxToRem(24),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'description-large': {
      desktop: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(28),
        lineHeight: pxToRem(36),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'description-medium': {
      desktop: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(22),
        lineHeight: pxToRem(28),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'button-cta': {
      desktop: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    price: {
      desktop: {
        fontWeight: convertWeight('bold'),
        fontSize: pxToRem(44),
        lineHeight: pxToRem(44),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('bold'),
        fontSize: pxToRem(36),
        lineHeight: pxToRem(36),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    body: {
      desktop: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(24),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    uppercase: {
      desktop: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(16),
        lineHeight: pxToRem(16),
        letterSpacing: pxToEm(0),
        textTransform: 'uppercase',
      },
      mobile: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(16),
        lineHeight: pxToRem(16),
        letterSpacing: pxToEm(0),
        textTransform: 'uppercase',
      },
    },
  },
  blog: {
    'article-title': {
      desktop: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(56),
        lineHeight: pxToRem(64),
        letterSpacing: pxToEm(-0.5),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(36),
        lineHeight: pxToRem(40),
        letterSpacing: pxToEm(-0.2),
        textTransform: 'none',
      },
    },
    'article-description': {
      desktop: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(22),
        lineHeight: pxToRem(32),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'section-title': {
      desktop: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(36),
        lineHeight: pxToRem(44),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(24),
        lineHeight: pxToRem(32),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'paragraph-title': {
      desktop: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(21),
        lineHeight: pxToRem(28),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('demibold'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(24),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'leading-content': {
      desktop: {
        fontWeight: convertWeight('light'),
        fontSize: pxToRem(25),
        lineHeight: pxToRem(32),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(20),
        lineHeight: pxToRem(27),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    body: {
      desktop: {
        fontWeight: convertWeight('light'),
        fontSize: pxToRem(21),
        lineHeight: pxToRem(30),
        letterSpacing: pxToEm(0.1),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(24),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    'body-small': {
      desktop: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(16),
        lineHeight: pxToRem(20),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    quote: {
      desktop: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(36),
        lineHeight: pxToRem(44),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('regular'),
        fontSize: pxToRem(20),
        lineHeight: pxToRem(27),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
    info: {
      desktop: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(16),
        lineHeight: pxToRem(16),
        letterSpacing: pxToEm(0.4),
        textTransform: 'uppercase',
      },
      mobile: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(16),
        lineHeight: pxToRem(16),
        letterSpacing: pxToEm(0.3),
        textTransform: 'uppercase',
      },
    },
    tag: {
      desktop: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(18),
        lineHeight: pxToRem(18),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
      mobile: {
        fontWeight: convertWeight('medium'),
        fontSize: pxToRem(16),
        lineHeight: pxToRem(16),
        letterSpacing: pxToEm(0),
        textTransform: 'none',
      },
    },
  },
}

export const marketingTypography = Object.entries(
  marketingTypographyConfig,
).reduce((typography, [weightName, weightConfig]) => {
  Object.entries(weightConfig).forEach(([styleName, styleConfig]) => {
    const name = `.text-${styleName}-${weightName}`

    const { desktop, mobile } = styleConfig

    typography[name] = {
      fontFamily: [
        'TT Commons',
        '-apple-system',
        'BlinkMacSystemFont',
        'Helvetica',
        'sans-serif',
      ].join(', '),
      fontSize: mobile.fontSize,
      lineHeight: mobile.lineHeight,
      fontWeight: `${mobile.fontWeight}`,
      letterSpacing: mobile.letterSpacing,
      textTransform: mobile.textTransform,

      '@media (min-width: 768px)': {
        fontSize: desktop.fontSize,
        lineHeight: desktop.lineHeight,
        fontWeight: `${desktop.fontWeight}`,
        letterSpacing: desktop.letterSpacing,
        textTransform: desktop.textTransform,
      },
    }
  })

  return typography
}, {} as Record<string, Partial<CSSStyleDeclaration | Record<string, Partial<CSSStyleDeclaration>>>>)

export const marketingTypographyPlugin = plugin(function createPlugin({
  addBase,
}) {
  addBase(marketingTypography)
})
